import { render, staticRenderFns } from "./RateModule.vue?vue&type=template&id=54dc9e3e"
import script from "./RateModule.vue?vue&type=script&lang=js"
export * from "./RateModule.vue?vue&type=script&lang=js"
import style0 from "./RateModule.vue?vue&type=style&index=0&id=54dc9e3e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports